import React, {useEffect, useState} from "react";
import {
    getBulkDropdownData,
} from "../../../api/keyvalue";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import {searchAuditReport} from "../../../api/auditReportApi";
import Grid from "../../Grid";
import {Card, CardContent} from "semantic-ui-react";
import {CheckSquare, Search} from "react-feather";

const AuditReportSearch = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [actionTypeData, setActionTypeData] = useState([])
    const [serviceTypeData, setServiceTypeData] = useState([])
    const [serviceTypeOpt, setServiceTypeOpt] = useState([])
    const [actionTypeOpt, setActionTypeOpt] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [reloadDates, setReloadDates] = useState(true);
    const [searchClicked, setSearchClicked] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [tab, setTab] = useState(1);
    const [activeAccordion1, setActiveAccordion1] = useState(true);
    const [resetVisible, setResetVisible] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true);

            const {
                service_type: serviceTypeOpt,
                audit_action_type: actionTypeOpt
            } = await getBulkDropdownData([
                {key: "service_type"},
                {key: "audit_action_type"}
            ]);
            setServiceTypeOpt(serviceTypeOpt);
            setActionTypeOpt(actionTypeOpt);

            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        if (reloadDates) {
            const aWeekAgo = new Date();
            aWeekAgo.setDate(aWeekAgo.getDate() - 7);
            const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
            const formattedToday = new Date().toISOString().split("T")[0];
            setFromDate(formattedWeekAgo);
            setToDate(formattedToday);
        }
        setReloadDates(false);
    }, [reloadDates]);

    const onSearch = async (e) => {
        e.preventDefault();
        setSearchClicked(true);
        setSearchLoading(true);

        try {
            const payload = {
                aulTypes: actionTypeData.length > 0 ? actionTypeData : null,
                aulModules: serviceTypeData.length > 0 ? serviceTypeData : null,
                fromDate,
                toDate
            };
            const response = await searchAuditReport(payload);

            setSearchResults(response || []);
        } catch (e) {
            console.error("Failed to fetch audit reports", e);
            setSearchResults([]);
        } finally {
            setSearchLoading(false);
        }
    };

    const onReset = (e) => {
        e.preventDefault();
        setActionTypeData([]);
        setServiceTypeData([]);
        setReloadDates(true);
        setSearchClicked(false);
        setSearchResults([]);
    };

    const handleReset = (e) => {
        e.preventDefault();
        if (tab === 1) {
            setSearchClicked(false);
            setResetVisible(false);
        }
    };

    return (
        <>
            <Card className="stakeholder-card-container">
                <CardContent>
                    <div
                        className="ui attached tabular"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                     >
                        <div className="ui tabular menu attached">
                            <div
                                className={`item ${tab === 1 ? "active" : ""}`}
                                onClick={() => {
                                    setTab(1);
                                }}
                            >
                                <span>
                                  <CheckSquare size={15} style={{ marginRight: "5px" }} />
                                </span>
                                Audit Report
                            </div>
                        </div>
                    </div>
                    <div
                        className="ui bottom attached active tab segment"
                        style={{ display: tab === 1 ? "block" : "none" }}
                    >
                        <div className="ui styled accordion" style={{ width: "100%" }}>
                            <div
                                className={`title ${activeAccordion1 ? "active" : ""}`}
                                onClick={() => setActiveAccordion1(!activeAccordion1)}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <span>Search</span>
                                        <Search size={14} style={{ marginLeft: "10px" }} />
                                        <i className="dropdown icon"></i>
                                    </div>

                                    <i
                                        className="refresh icon primary button"
                                        style={{
                                            display: `${resetVisible ? "flex" : "none"}`,
                                            cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                            handleReset(e);
                                        }}
                                    ></i>
                                </div>
                            </div>

                        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
                    {isLoading ? (
                        <LoadingSpinner/>
                    ) : (
                        <form className="ui form">
                            <div
                                className="two fields"
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <div className="field">
                                    <Dropdown
                                        label="Action Type"
                                        options={actionTypeOpt}
                                        multiple={true}
                                        search={true}
                                        placeholder="action type"
                                        style={{height: "20px"}}
                                        value={actionTypeData}
                                        onChange={(e, data) => {
                                            setActionTypeData(data.value);
                                        }}
                                    />
                                </div>
                                <div className="field">
                                    <Dropdown
                                        label="Service Type"
                                        options={serviceTypeOpt}
                                        multiple={true}
                                        search={true}
                                        placeholder="service"
                                        style={{height: "20px"}}
                                        value={serviceTypeData}
                                        onChange={(e, data) => {
                                            setServiceTypeData(data.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div
                                className="two fields">
                                <div className="field">
                                    <Input
                                        type="date"
                                        label="From Date"
                                        name="fromDate"
                                        max={toDate ?? new Date().toISOString().split("T")[0]}
                                        value={fromDate}
                                        onChange={(e) => {
                                            setFromDate(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className="field">
                                    <Input
                                        label="To Date"
                                        type="date"
                                        name="toDate"
                                        min={fromDate}
                                        value={toDate}
                                        disabled={!fromDate}
                                        onChange={(e) => {
                                            setToDate(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <div className="field" style={{width: "100%"}}>
                                    <Button template="search" onClick={onSearch}/>
                                    <Button template="searchReset" onClick={onReset}/>
                                </div>
                            </div>
                        </form>
                    )}
                        </div>
                        </div>
                    {searchClicked && (
                        <>
                            {searchLoading ? (
                                <LoadingSpinner/>
                            ) : (
                                <Grid
                                    content={searchResults}
                                    config={[
                                        {headerName: "Action Type", field: "aulTypeName"},
                                        {headerName: "Service Type", field: "aulServiceName"},
                                        {headerName: "Action", field: "aulAction"},
                                        {headerName: "User", field: "aulUser"},
                                        {headerName: "Date", field: "aulDate"}
                                    ]}
                                />
                            )}
                        </>
                    )}
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

export default AuditReportSearch;
